import type { ReactNode } from 'react'

import { cn } from '../lib/cn'
import { t } from '../lib/i18n'

export interface DangerRow {
  id: string
  label: ReactNode
  description: ReactNode
  action: ReactNode
}

/**
 * "Careful" rather than "Danger zone", and every row states its consequence in
 * the reader's own terms. These affect a real business that is trading today.
 */
export function DangerZone({
  body,
  rows,
  className,
}: {
  body: ReactNode
  rows: DangerRow[]
  className?: string
}) {
  return (
    <section
      className={cn('rounded-r2 border border-danger/25 bg-danger/5 p-[17px]', className)}
      aria-labelledby="danger-zone-title"
    >
      <h2 id="danger-zone-title" className="mb-1 font-display text-sm font-bold text-danger">
        {t('danger.title')}
      </h2>
      <p className="mb-3 text-[12.5px] leading-relaxed text-sub">{body}</p>
      {rows.map((row) => (
        <div
          key={row.id}
          className="flex items-center justify-between gap-3.5 border-t border-danger/15 py-2.5"
        >
          <div className="min-w-0">
            <div className="text-[13px] font-semibold text-dark">{row.label}</div>
            <div className="mt-0.5 text-[11.5px] leading-snug text-muted">{row.description}</div>
          </div>
          <div className="shrink-0">{row.action}</div>
        </div>
      ))}
    </section>
  )
}
